import { useSearchParams } from "#src/Routers/hooks";
import { WorkflowTasksListLayout } from "#src/batteries-included-components/Layouts/Workflows/Tasks/List";
import { useAuthenticatedContext } from "#src/contexts/AuthenticatedContext.helpers";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import {
  generateDocumentTitle,
  Page,
  Tab,
} from "@validereinc/common-components";
import { ResourceDefinitions } from "@validereinc/domain";
import React from "react";
import { Titled } from "react-titled";
import { WorkflowTasksRoutePath } from "./";

const DEFAULT_TAB_KEY = "my-tasks";

export const WorkflowMyTasksPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [breadcrumbs] = useBreadcrumbsFromRoute(WorkflowTasksRoutePath);
  const {
    v2: { userInfo },
  } = useAuthenticatedContext();

  // My tasks and all tasks have two different set of filters that in conflict.
  // Therefore two different filters:
  const myTasksStorageKeys = useStorageKey(
    [
      "filter-configuration",
      "table-configuration",
      "view-configuration",
      "table-state",
      "group-by-tables-state",
    ],
    ["workflows", "tasks", "list", "my"]
  );
  const allTasksStorageKeys = useStorageKey(
    [
      "filter-configuration",
      "table-configuration",
      "view-configuration",
      "table-state",
      "group-by-tables-state",
    ],
    ["workflows", "tasks", "list", "all"]
  );

  return (
    <Page
      category={WorkflowTasksRoutePath.subtitle}
      title={WorkflowTasksRoutePath.title}
      breadcrumbs={breadcrumbs}
      activeTabKey={searchParams?.tab ?? DEFAULT_TAB_KEY}
      onActiveTabKeyChange={(tabKey: string) => {
        setSearchParams({ tab: tabKey });
      }}
    >
      <Tab
        title="My Tasks"
        tabKey="my-tasks"
      >
        <Titled
          title={generateDocumentTitle(
            `My ${ResourceDefinitions.workflow_task.label.plural}`
          )}
        >
          <WorkflowTasksListLayout
            isDisplayingMyTasks
            tablePanelProps={{
              filterConfigStorageKey: myTasksStorageKeys[0],
              tableConfigStorageKey: myTasksStorageKeys[1],
              viewConfigStorageKey: myTasksStorageKeys[2],
              tableStateStorageKey: myTasksStorageKeys[3],
              groupByTablesStateStorageKey: myTasksStorageKeys[4],
              taskFilters: {
                $or: [
                  {
                    assignee_user: userInfo.user?.id,
                  },
                  {
                    "assignee_group.user_id": userInfo.user?.id,
                  },
                ],
              } as any,
            }}
          />
        </Titled>
      </Tab>
      <Tab
        title="All Tasks"
        tabKey="all-tasks"
      >
        <Titled
          title={generateDocumentTitle(
            `All ${ResourceDefinitions.workflow_task.label.plural}`
          )}
        >
          <WorkflowTasksListLayout
            tablePanelProps={{
              filterConfigStorageKey: allTasksStorageKeys[0],
              tableConfigStorageKey: allTasksStorageKeys[1],
              viewConfigStorageKey: allTasksStorageKeys[2],
              tableStateStorageKey: allTasksStorageKeys[3],
              groupByTablesStateStorageKey: allTasksStorageKeys[4],
              taskFilters: {},
            }}
          />
        </Titled>
      </Tab>
    </Page>
  );
};
